import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

const createLayoutStackGap = (unit: ThemeUnit) =>
  ({
    condensed: pxToUnit(4, unit),
    normal: pxToUnit(8, unit),
    spacious: pxToUnit(16, unit),
  }) as const;

export const layoutStackGapRem = createLayoutStackGap("rem");

const createLayoutStackPadding = (unit: ThemeUnit) =>
  ({
    condensed: pxToUnit(4, unit),
    normal: pxToUnit(8, unit),
    spacious: pxToUnit(16, unit),
  }) as const;

export const layoutStackPaddingRem = createLayoutStackPadding("rem");
